import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Image',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: __props.fillColor,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("rect", {
      x: "11",
      y: "13",
      width: "26",
      height: "22",
      stroke: __props.strokeColor,
      "stroke-width": "2"
    }, null, 8 /* PROPS */, _hoisted_2),
    _createElementVNode("path", {
      d: "M13 35.0002L21.9304 26.3508C22.4665 25.8316 22.7346 25.5719 23.0437 25.4747C23.3156 25.3891 23.6085 25.3891 23.8804 25.4747C24.1895 25.5719 24.4576 25.8316 24.9937 26.3508L33.8645 34.9425M26.1696 27.4898L30.0532 23.7284C30.5893 23.2092 30.8574 22.9495 31.1665 22.8523C31.4384 22.7667 31.7313 22.7667 32.0032 22.8523C32.3123 22.9495 32.5803 23.2092 33.1165 23.7284L37 27.4898",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_3),
    _createElementVNode("path", {
      d: "M17.5 23C18.8807 23 20 21.8807 20 20.5C20 19.1193 18.8807 18 17.5 18C16.1193 18 15 19.1193 15 20.5C15 21.8807 16.1193 23 17.5 23Z",
      stroke: __props.strokeColor,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8 /* PROPS */, _hoisted_4)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})